import { getBreakpoint } from '@front/utils';
import { debounce } from 'lodash-es';
import Swiper, { SwiperOptions, Mousewheel } from 'swiper';
import { createComponent } from '@front/utils/alpine';

const nav = createComponent(() => ({
    setup () {
        const navItems = document.querySelectorAll('.prestablog-cat > ul > li > a');

        navItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                if (window.matchMedia("(pointer: coarse)").matches) {
                    e.preventDefault();
                }
            });
        })
    }
}));

const slider = createComponent(() => ({
    setup () {
        const reload = debounce(() => {
            slider.el.querySelectorAll('.swiper-slide-duplicate').forEach((el) => el.remove());
            slider.destroy();
            slider = new Swiper(this.$el, config);
        }, 200);

        const config: SwiperOptions = {
            modules: [Mousewheel],
            slidesPerView: 3,
            initialSlide: 1,
            centeredSlides: true,
            loop: true,
            mousewheel: true,
            breakpoints: {
                [getBreakpoint('md')]: {
                    mousewheel: false,
                    loop: false,
                    centeredSlides: false,
                }
            },
            on: {
                init () {
                    window.addEventListener('resize', reload);
                },
                destroy () {
                    window.removeEventListener('resize', reload);
                },
            },
        }

        let slider = new Swiper(this.$el, config);
    },
}));

export default {
    nav,
    slider,
};
